import { getLogoOrImageConfig } from "@website-builder/utilities-index";
import { getBluryAndLazyImageUrl } from "@website-builder/utilities-index";

export default (
	{ imageConfig = null, mobileImage = null },
	{ basicConfig },
) => {
	return {
		imageConfig: imageConfig && getLogoOrImageConfig(imageConfig, basicConfig),
		mobileImage: mobileImage && getBluryAndLazyImageUrl(mobileImage?.image),
	};
};
